import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Grid,
  Typography,
  TextField,
} from "@mui/material";

import axios from "axios";
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------
const dateFormat = "YYYY-MM-DD HH:mm:ss";
export default function NewCustomGamePage() {
  const navigate = useNavigate();
  const [gameStart, setGameStart] = useState();
  const [name, setName] = useState("");

  const handlePickemStartChange = (newValue) => {
    setGameStart(newValue);
  };
  const handleSubmit = () => {
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/admin/games`, {
        matchId: 1,
        name,
        kickoff: moment(gameStart).format(dateFormat),
      })
      .then(function (response) {
        navigate("/dashboard/games");
      });
  };

  return (
    <>
      <Helmet>
        <title> Bingo Games </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Create Bingo Game
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6} md={6}>
              <TextField
                id="name"
                label="Game Title"
                type="email"
                fullWidth
                value={name}
                variant="standard"
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="Start UTC"
                  value={gameStart}
                  onChange={handlePickemStartChange}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Button
                variant="contained"
                disabled={name.length < 3}
                onClick={() => handleSubmit()}
              >
                Create
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </>
  );
}
